(() => {
  const eventNames = new Set(['page_view', 'view_item', 'add_to_cart', 'view_cart', 'begin_checkout']);
  const emitted = new Set();

  const createEventId = () => {
    if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  };

  const emit = (name, scope = '') => {
    if (!eventNames.has(name)) return;
    const dedupeKey = `${name}:${scope}`;
    if (emitted.has(dedupeKey)) return;
    emitted.add(dedupeKey);

    const detail = {
      event: name,
      event_id: createEventId(),
      page_type: document.body.dataset.pcpTemplate || 'unknown',
      product_handle: document.body.dataset.pcpProductHandle || undefined,
    };

    document.dispatchEvent(new CustomEvent('pcp:funnel-event', { detail }));
  };

  const template = document.body.dataset.pcpTemplate;
  const productHandle = document.body.dataset.pcpProductHandle;

  emit('page_view');
  if (template === 'product' && productHandle) emit('view_item', productHandle);
  if (template === 'cart') emit('view_cart');

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.dataset.pcpEvent = 'add_to_cart';
    form.addEventListener('submit', () => emit('add_to_cart', form.querySelector('[name="id"]')?.value || 'product'));
  });

  document.querySelectorAll('a[href*="/checkout"], button[name="checkout"]').forEach((control) => {
    control.dataset.pcpEvent = 'begin_checkout';
    control.addEventListener('click', () => emit('begin_checkout', control.getAttribute('href') || 'checkout'));
  });
})();
